import React from 'react';
import { Paper, Typography, Box, LinearProgress } from '@mui/material';

// Компонент для отображения статистических карточек
export const StatCard = ({ 
  title, 
  value, 
  subtitle, 
  icon, 
  color = '#fff', 
  background = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  progress = null,
  sx = {} 
}) => {
  return (
    <Paper
      sx={{
        p: 3,
        background,
        color: 'white',
        height: '100%',
        ...sx
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        {icon && (
          <Box sx={{ mr: 2, fontSize: 28 }}>
            {icon}
          </Box>
        )}
        <Box sx={{ flex: 1 }}>
          <Typography variant="h4" sx={{ color, fontWeight: 'bold' }}>
            {value}
          </Typography>
          <Typography variant="caption" sx={{ color, opacity: 0.9 }}>
            {title}
          </Typography>
        </Box>
      </Box>
      {subtitle && (
        <Typography variant="body2" sx={{ color, opacity: 0.8, mb: 1 }}>
          {subtitle}
        </Typography>
      )}
      {progress !== null && (
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{ 
            backgroundColor: 'rgba(255,255,255,0.3)', 
            '& .MuiLinearProgress-bar': { backgroundColor: 'white' } 
          }}
        />
      )}
    </Paper>
  );
};

// Предустановленные градиенты для карточек
export const cardGradients = {
  purple: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  blue: 'linear-gradient(135deg, #00c6fb 0%, #005bea 100%)',
  green: 'linear-gradient(135deg, #4caf50 0%, #2e7d32 100%)',
  orange: 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)',
  red: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
  pink: 'linear-gradient(135deg, #ec4899 0%, #be185d 100%)',
  teal: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)'
};